import { SPLIT_LABEL, splitInfoKeyMapping } from './constants';

const getExperimentSplitType = (type, unit) => {
    // For Experiment Split, we check 'abSplitTestData', and for Multi Split, we check 'multiSplitTestData'
    const dataKey = splitInfoKeyMapping[type];
    const splitType = unit?.[dataKey]?.splitType; // checks for 'experiment' or 'control'

    return splitType;
};

export const getExperimentSplitInfoOfSection = (sectionLevelSplit = {}, unitData, units) => {
    if (!sectionLevelSplit?.enabled) return false;

    const { sectionRef, videoSectionId } = unitData;
    const splitDetails = sectionLevelSplit.splits?.[videoSectionId] || {};
    const { type } = splitDetails;

    // 1. Handle Normal Split
    if (type === 'NORMAL_SPLIT') {
        const perc = splitDetails.splitPercentage ?? 0;
        return `[${SPLIT_LABEL.normal}-${perc}%]`;
    }

    // 2. Handle Experiment/Multi Splits
    const isExperiment = type === 'EXPERIMENT_SPLIT';
    const isMulti = type === 'MULTI_SPLIT';

    if (isExperiment || isMulti) {
        const unit = units?.[sectionRef];
        if (!unit) return '';

        const splitType = getExperimentSplitType(type, unit);
        const label = SPLIT_LABEL[splitType]; // set appropriate label based on splitType
        const perc = splitDetails.controlExperimentSplits?.[sectionRef]?.splitPercentage ?? 0;

        return `[${label}-${perc}%]`;
    }

    return '';
};